let map;
let markers = []; // Array to hold all map markers

function initMap() {
    // Define locations with corresponding custom icons and addresses
    const locations = [
        {
            latitude: 35.683417542887675,
            longitude: 139.78313893336545,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒103-0014 東京都中央区日本橋蛎殻町1丁目28番5号",
            region: "tokyo",
            city: "東京都中央区",
            service: "車検",
            templateId: "template1",
        },
        {
            latitude: 35.683182250434314,
            longitude: 139.78322476404446,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒103-0014 東京都中央区日本橋蛎殻町1丁目28番5号",
            region: "tokyo",
            city: "東京都中央区",
            service: "車検",
            templateId: "template2",
        },
        {
            latitude: 37.92101110187366,
            longitude: 139.06205901349534,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒950-0077 新潟県新潟市中央区天明町16番7号",
            region: "nigata",
            city: "新潟県新潟市中央区",
            service: "車検",
            templateId: "template3",
        },
        {
            latitude: 37.37263921470479,
            longitude: 140.39504369815583,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒963-0725 福島県郡山市田村町金屋字川久保41番地",
            region: "fukushima",
            city: "福島県郡山市田村町",
            service: "キーパーコーティング",
        },
        {
            latitude: 37.514286964681226,
            longitude: 139.91223884084033,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒965-0057 福島県会津若松市町北町大字藤室字横道145番2号",
            region: "fukushima",
            city: "福島県会津若松市町",
            service: "キーパーコーティング",
        },
        {
            latitude: 38.26352652868186,
            longitude: 140.9595475242737,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒983-0034 宮城県仙台市宮城野区扇町7丁目6番12号",
            region: "miyagi",
            city: "宮城県仙台市宮城野区",
            service: "洗車",
        },
        {
            latitude: 38.254862929459705,
            longitude: 140.93891075093276,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒984-0011 宮城県仙台市若林区六丁の目西町7番3号",
            region: "miyagi",
            city: "宮城県仙台市若林区",
            service: "洗車",
        },
        {
            latitude: 38.327620472180605,
            longitude: 141.04218522514657,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒985-0001 宮城県塩釜市新浜町1-17-19 202",
            region: "miyagi",
            city: "宮城県塩釜市新浜町",
            service: "洗車",
        },
        {
            latitude: 38.41376396814481,
            longitude: 141.33979248348794,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒986-0022 宮城県石巻市魚町3丁目11番5号",
            region: "miyagi",
            city: "宮城県石巻市魚町",
            service: "エンジンオイル",
        },
        {
            latitude: 38.90286315829923,
            longitude: 141.57935619999998,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒988-0021 宮城県気仙沼市港町503-6 2階 （宮城県漁業協同組合気仙沼総合支所内）",
            region: "miyagi",
            city: "宮城県気仙沼市港町",
            service: "車検",
        },
        {
            latitude: 39.6880171033552,
            longitude: 141.17937131840955,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒020-0811 岩手県盛岡市川目町1番5号",
            region: "iwate",
            city: "岩手県盛岡市川目町",
            service: "車検",
        },
        {
            latitude: 39.75250327782012,
            longitude: 141.09827823472145,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒020-0172 岩手県滝沢市鵜飼諸葛川1番1号",
            region: "iwate",
            city: "岩手県滝沢市鵜飼諸葛川",
            service: "タイヤ交換",
        },
        {
            latitude: 39.2755449589443,
            longitude: 141.88377312883486,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒026-0021 岩手県釜石市只越町3丁目4番2号 南天ビル2階",
            region: "iwate",
            city: "岩手県釜石市只越町",
            service: "クイック板金",
        },
        {
            latitude: 39.7507079830454,
            longitude: 140.06472331718365,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒011-0945 秋田県秋田市土崎港西1丁目5番1号",
            region: "akita",
            city: "秋田県秋田市土崎港西",
            service: "車検",
        },
        {
            latitude: 40.7890346023395,
            longitude: 140.75861803727366,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒030-0131 青森県青森市問屋町1丁目6番20号",
            region: "aomori",
            city: "青森県青森市問屋町",
            service: "車を買う",
        },
        {
            latitude: 40.815006021541315,
            longitude: 140.78507626130553,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒030-0964 青森県青森市南佃2丁目13番12号",
            region: "aomori",
            city: "青森県青森市南佃",
            service: "車を売る",
        },
        {
            latitude: 40.789152168571775,
            longitude: 140.75864975582562,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒030-0131 青森県青森市問屋町1丁目6番20号",
            region: "aomori",
            city: "青森県青森市問屋町",
            service: "車検",
        },
        {
            latitude: 40.62085900455105,
            longitude: 140.48561218650462,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒036-8061 青森県弘前市大字神田2丁目4番地25",
            region: "aomori",
            city: "青森県弘前市大字神田",
            service: "車を借りる",
        },
        {
            latitude: 40.52800703957409,
            longitude: 141.52763664417438,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒031-0811 青森県八戸市新湊3丁目6番12号",
            region: "aomori",
            city: "青森県八戸市新湊",
            service: "損害保険",
        },
        {
            latitude: 40.5265957683276,
            longitude: 141.53251937300928,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒031-0811 青森県八戸市大字湊町字大沢36番3号",
            region: "aomori",
            city: "青森県八戸市大字湊町字大沢",
            service: "生命保険",
        },
        {
            latitude: 42.66134316918646,
            longitude: 141.62461927116513,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒053-0055 北海道苫小牧市新明町4丁目2番2号",
            region: "hokkaido",
            city: "北海道苫小牧市新明町",
            service: "車検",
        },
        {
            latitude: 42.316436995676604,
            longitude: 140.97155748712294,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒051-0011 北海道室蘭市中央町2丁目7番13号 米塚ビル5F",
            region: "hokkaido",
            city: "北海道室蘭市中央町",
            service: "灯油配送",
        },
        {
            latitude: 42.30869574059617,
            longitude: 140.97076661351136,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒051-0013 北海道室蘭市舟見町1丁目139番地",
            region: "hokkaido",
            city: "北海道室蘭市舟見町",
            service: "車検",
        },
        {
            latitude: 41.76854999574721,
            longitude: 140.7305987233024,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒040-0036 北海道函館市東雲町8番12号",
            region: "hokkaido",
            city: "北海道函館市東雲町",
            service: "車検",
        },
        {
            latitude: 43.21091276054228,
            longitude: 141.00679738466047,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒047-0041 北海道小樽市手宮1丁目4番2号",
            region: "hokkaido",
            city: "北海道小樽市手宮",
            service: "車検",
        },
        {
            latitude: 43.123925900858026,
            longitude: 141.36140705113752,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒047-0041 北海道小樽市手宮1丁目4番2号〒007-0847 北海道札幌市東区北47条東13丁目3番10号",
            region: "hokkaido",
            city: "北海道小樽市手宮",
            service: "きたでん",
        },
        {
            latitude: 43.01672778402035,
            longitude: 144.38418796013752,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒085-0063 北海道釧路市文苑1丁目22番11号",
            region: "hokkaido",
            city: "北海道釧路市文苑",
            service: "車検",
        },
        {
            latitude: 43.489150797167454,
            longitude: 144.81667913374906,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒088-2682 北海道標津郡中標津町計根別南1条東4丁目1番",
            region: "hokkaido",
            city: "北海道標津郡中標津町計根別南",
            service: "車検",
        },
        {
            latitude: 43.05169423505693,
            longitude: 144.8464493822087,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒088-1151 北海道厚岸郡厚岸町真栄2丁目267番地",
            region: "hokkaido",
            city: "北海道厚岸郡厚岸町真栄",
            service: "車検",
        },
        {
            latitude: 43.81510941338224,
            longitude: 143.87865728650462,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒090-0066 北海道北見市花月町15番地8",
            region: "hokkaido",
            city: "北海道北見市花月町",
            service: "車検",
        },
        {
            latitude: 44.01904691031816,
            longitude: 144.28596395707282,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒093-0032 北海道網走市港町4番地93",
            region: "hokkaido",
            city: "北海道網走市港町",
            service: "車検",
        },
        {
            latitude: 44.35759898494724,
            longitude: 143.35695802883487,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒094-0011 北海道紋別市本町1丁目1番3号",
            region: "hokkaido",
            city: "北海道紋別市本町",
            service: "きたでん",
        },
        {
            latitude: 44.34883320136632,
            longitude: 143.3573558558256,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒094-0011 北海道紋別市港町7丁目5番19号",
            region: "hokkaido",
            city: "北海道紋別市港町",
            service: "きたでん",
        },
        {
            latitude: 44.32275145426123,
            longitude: 143.3444538,
            icon: base_url + "/assets/img/location-icon.svg",
            address: "〒094-0022 北海道紋別市新生10番2号",
            region: "hokkaido",
            city: "北海道紋別市新生1",
            service: "きたでん",
        },
    ];

    const shops_element = document.querySelector("[data-shops]");

    const shops = shops_element ? JSON.parse(shops_element.textContent) : locations;

    const mapCenter = { lat: 35.6830951049055, lng: 139.78326767938395 }; // Center on Tokyo

    let zoom = 5;
    if (shops_element && shops.length > 0) {
        mapCenter.lat = shops[0].latitude;
        mapCenter.lng = shops[0].longitude;
        zoom = 15;
    }

    map = new google.maps.Map(document.getElementById("map"), {
        zoom: zoom,
        center: mapCenter,
    });

    // Render all markers initially
    renderMarkers(shops);

    // Search form submission event listener (keeps filtering functionality)
    // document.getElementById('top__service-submit').addEventListener('click', function (event) {
    //     event.preventDefault(); // Prevent form submission

    //     // Get selected values from dropdowns
    //     const selectedRegion = document.getElementById('select-1').value;
    //     const selectedCity = document.getElementById('select-2').value;
    //     const selectedService = document.getElementById('select-3').value;

    //     // Filter locations based on selected options
    //     let filteredLocations = locations;

    //     if (selectedRegion) {
    //         filteredLocations = filteredLocations.filter((location) => location.region === selectedRegion);
    //     }
    //     if (selectedCity) {
    //         filteredLocations = filteredLocations.filter((location) => location.city === selectedCity);
    //     }
    //     if (selectedService) {
    //         filteredLocations = filteredLocations.filter((location) => location.service === selectedService);
    //     }

    //     // Clear existing markers
    //     clearMarkers();

    //     // Render filtered markers
    //     renderMarkers(filteredLocations);
    // });
}

// Function to render markers
function renderMarkers(locations) {
    const bounds = new google.maps.LatLngBounds(); // Create bounds object

    locations.forEach((location) => {
        const marker = new google.maps.Marker({
            position: { lat: location.latitude, lng: location.longitude },
            map: map,
            icon: location.icon ? location.icon : base_url + "/assets/img/location-icon.svg", // Set the custom icon for each marker
        });

        // Add a click event listener to trigger modal opening
        marker.addListener("click", function () {
            showModal(location.templateId); // Open modal with the templateId
        });

        // Extend the map bounds to include this marker
        bounds.extend(marker.position);

        // Store marker in the markers array
        markers.push(marker);
    });

    // Adjust the map to fit all markers within the visible area
    if (locations.length > 0) {
        map.fitBounds(bounds);
    }
}

// Function to show modal based on template ID
function showModal(templateId) {
    const dialog = document.getElementById("favDialog");
    const contentMain = dialog.querySelector(".content-main");

    // Get the template content by its ID
    const template = document.getElementById(templateId);
    if (template) {
        // Clear the previous content
        contentMain.innerHTML = "";

        // Append the new content from the template
        contentMain.appendChild(template.content.cloneNode(true));

        // Show the dialog
        dialog.showModal();
    }
}

// Function to clear all markers from the map
function clearMarkers() {
    markers.forEach((marker) => {
        marker.setMap(null);
    });
    markers = [];
}

window.onload = initMap;
